export const VERIFY_DETAIL_ZHCHS = {
    vertifyTypeAll: 'å¨é¨',
    vertifyTypeError: 'éå¡«',
    vertifyTypeEmpty: 'æ¼å¡«'
};
